import { FC, ReactNode } from 'react';
import { IonText } from '@ionic/react';
import { createUseStyles } from 'react-jss';
import { IThemeColor } from '../theme/IThemeColor';

const useStyles = createUseStyles({
    title: {
        fontSize: 18,
        fontWeight: 600
    },
    subtitle: {
        fontWeight: 600
    },
    detail: {
    },
    subdetail: {
        fontSize: 16,
    },
    normal: {
        fontSize: 16, // .card-content-md makes font size 0.875rem
    }
});

export interface ITextProps {
    'data-type'?: string;
    type?: 'title' | 'subtitle' | 'detail' | 'subdetail' | 'normal';
    disabled?: boolean;
    ellipsize?: boolean;
    children: ReactNode;
    color?: IThemeColor;
};

export const Text: FC<ITextProps> = ({
    'data-type': dataType,
    type = 'normal',
    disabled = false,
    ellipsize = false,
    children,
    color,
}) => {
    const classes = useStyles();

    let styleColor: string | undefined;
    if (!color) {
        if (disabled) {
            styleColor = 'var(--ion-color-step-500)';
        }
        else if (type === 'subtitle' || type === 'detail' || type === 'subdetail') {
            styleColor = 'var(--ion-color-step-750)';
        }
    }

    const ellipsisClass = (ellipsize ? 'ellipsis' : '');

    return (
        <IonText
            data-type={dataType}
            color={color}
            className={`${classes[type]} ${ellipsisClass}`}
            style={{color: styleColor, display: 'block'}}
        >
            {children}
        </IonText>
    );
};
